export default "__VITE_ASSET__BvLdcnEL__"